<!-- prettier-ignore -->
 
<ion-header (click)="dismissModal()">
    <ion-toolbar class="iframe-toolbar">
        @if(title){
            <ion-title>{{title}}</ion-title>
        }
      <ion-buttons slot="end">
        <ion-icon name="close"></ion-icon>
      </ion-buttons>
    </ion-toolbar>
</ion-header>
   
<ion-content class="iframe-wrapper">
    <iframe [src]="iframeSrc" frameborder="0" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-presentation" allowfullscreen></iframe>
</ion-content>
  